import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';

import { IMAGE_SIZE_CODE } from '../../../../constants/image-size-codes';
import CheckoutItemQuantityInput from './CheckoutItemQuantityInput';
import TrashIcon from '../../../../components/icons/TrashIcon';
import { PrintProductConfiguratorModal } from '../../../prints/components/PrintProductConfigurator';
import PrintProductSizeRoesConfiguratorModal from '../../../../apps/pro/views/HierarchyItem/Matches/components/PurchasingOptions/components/PrintProductsGroup/components/PrintProductSizeRoesConfigurator';
import Button from '../../../../components/global/Button';
import CartItemVendor from './CartItemVendor';
import Badge from '../../../../components/global/Badge';
import PrinterIcon from '../../../../components/icons/PrinterIcon';
import CartItemPhotoPreview from './CartItemPhotoPreview';
import { getPhotoPricingPrintBackgrounds } from '../../../../util/photo-pricings';
import useIdentityJerseyColors from '../../../../apps/pro/views/HierarchyItem/Matches/hooks/useIdentityJerseyColors';

const propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    photo: PropTypes.shape({
      id: PropTypes.string.isRequired,
      thumbnail_urls: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string.isRequired,
          width: PropTypes.number.isRequired,
          height: PropTypes.number.isRequired,
          size_code: PropTypes.oneOf(Object.values(IMAGE_SIZE_CODE)).isRequired,
        }).isRequired,
      ).isRequired,
    }).isRequired,
    quantity: PropTypes.number.isRequired,
    watermark: PropTypes.bool.isRequired,
  }).isRequired,
  onRemove: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  watermarkSettings: PropTypes.shape({
    wallpaperCustomText: PropTypes.string,
    wallpaperFontSize: PropTypes.number,
  }),
};

const PurchasedPhotoPricingPrintProductCartItem = ({
  item,
  onRemove,
  onUpdate,
  watermarkSettings,
}) => {
  const [configuringPrintProduct, setConfiguringPrintProduct] = useState(false);
  const {
    quantity,
    accountCard,
    photo,
    identity,
    albumMembershipGroup,
    purchasedPhotoPricing,
    roesConfiguration,
    isAllPhotos = false,
    photoPricing,
  } = item;

  const { photo_pricing_print_product_item: printProductItem } =
    purchasedPhotoPricing ?? {};
  const {
    print_product_configuration: {
      name: productName,
      print_product: printProduct,
      print_product_size: printProductSize,
    },
  } = printProductItem;

  const { jerseyColors } = useIdentityJerseyColors({
    identityId: identity?.id,
    albumFolderId:
      albumMembershipGroup?.album_folder?.id ??
      albumMembershipGroup?.album?.root_album_folder?.id,
  });

  const printBackgrounds = photo?.foreground?.original_url
    ? getPhotoPricingPrintBackgrounds(
        photoPricing,
        albumMembershipGroup,
        jerseyColors,
      )
    : [];

  return (
    <Fragment>
      <div className="checkout-cart-item checkout-individual-print-cart-item">
        <div className="checkout-cart-item-content">
          <div className="checkout-cart-item-figure">
            <CartItemPhotoPreview
              photo={item.photo}
              watermarkSettings={watermarkSettings}
            >
              <span className="checkout-cart-item-photo-icon">
                <PrinterIcon color="#0e84fe" size={18} />
              </span>
            </CartItemPhotoPreview>
          </div>

          <div className="checkout-cart-item-info">
            <span className="checkout-cart-item-title">{productName}</span>
            <Badge className="text-extra-bold" badgeStyle="yellow">
              PAID
            </Badge>
            <CartItemVendor cartItem={item} />
            <div className="checkout-cart-item-info-actions mt-2">
              <CheckoutItemQuantityInput
                onChange={value =>
                  onUpdate(item.id, {
                    quantity: value,
                  })
                }
                value={quantity}
                removeButtons
              />

              <button
                className="checkout-cart-item-btn-remove"
                onClick={() => onRemove(item.id)}
              >
                <TrashIcon color="#fe5851" size={18} />
              </button>
            </div>
          </div>
        </div>
        <Button
          btnSize="xs"
          onClick={() => setConfiguringPrintProduct(true)}
          className="purchasing-options-item-btn"
          btnStyle="link"
        >
          {accountCard ? `View & Edit` : `Edit configuration`}
        </Button>
      </div>
      {configuringPrintProduct && accountCard && (
        <PrintProductConfiguratorModal
          forceOpen
          controlsDisabled
          printProductId={printProduct.id}
          printProductSizeId={printProductSize.id}
          photo={photo}
          onClose={() => {
            setConfiguringPrintProduct(false);
          }}
          onComplete={() => {
            setConfiguringPrintProduct(false);
          }}
          defaultAccountCard={accountCard}
          buttonText="Update"
          albumMembershipGroup={albumMembershipGroup}
          identity={identity}
          printBackgrounds={printBackgrounds}
        />
      )}
      {configuringPrintProduct && !accountCard && roesConfiguration && (
        <PrintProductSizeRoesConfiguratorModal
          isInCart
          forceOpen
          photo={photo}
          defaultConfiguration={roesConfiguration}
          printProduct={printProduct}
          printProductSize={printProductSize}
          albumMembershipGroup={albumMembershipGroup}
          isAllPhotos={isAllPhotos}
          onComplete={({ roesConfiguration: newConfiguration }) => {
            onUpdate(item.id, {
              roesConfiguration: newConfiguration,
            });
            setConfiguringPrintProduct(false);
          }}
          onClose={() => {
            setConfiguringPrintProduct(false);
          }}
        />
      )}
    </Fragment>
  );
};

PurchasedPhotoPricingPrintProductCartItem.propTypes = propTypes;

export default PurchasedPhotoPricingPrintProductCartItem;
